import { get, post, put, destroy } from './base';
export const CommonServe = {
    index: (params) => get('/common', { params: params }),
    single: (id) =>
        get(`/common/${id}`),
    uploadfiletos3: async(payload) => {
       return post('/common/uploadfiletos3', payload, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        )
    },
    update: (id, payload) => put(`/common/${id}`, payload),
    remove: (id) => destroy(`/common/${id}`),
}